export const CITIES = ["Jakarta", "Bandung", "Yogyakarta", "Solo", "Surabaya", "Bali"];

export const CATEGORIES = ["Semua", "Museum", "Crafting", "Restaurant", "Wisata Alam", "Rides"];

// stock image pools for non-Jakarta cities
const IMG = {
  pottery: "https://images.pexels.com/photos/38933740/pexels-photo-38933740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pottery2: "https://images.pexels.com/photos/10111544/pexels-photo-10111544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  batik: "https://images.pexels.com/photos/35189098/pexels-photo-35189098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  batik2: "https://images.pexels.com/photos/10682942/pexels-photo-10682942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  garden: "https://images.pexels.com/photos/5116976/pexels-photo-5116976.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  garden2: "https://images.pexels.com/photos/18823982/pexels-photo-18823982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallery: "https://images.pexels.com/photos/9329047/pexels-photo-9329047.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallery2: "https://images.unsplash.com/photo-1572267148520-11f9b4b5f50a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ferris: "https://images.pexels.com/photos/36879880/pexels-photo-36879880.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ferris2: "https://images.unsplash.com/photo-1484587658517-51c2ea232f9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lake: "https://images.pexels.com/photos/28579283/pexels-photo-28579283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  lake2: "https://images.unsplash.com/photo-1762392084847-37d6ecb01a03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bali: "https://images.unsplash.com/photo-1662950267280-0cdf5f7139b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bali2: "https://images.unsplash.com/photo-1693625656620-e2ffa01fa81a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bandungCafe: "https://images.unsplash.com/photo-1665958392541-c21949431ee4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bandungMt: "https://images.unsplash.com/photo-1602027307997-6b25a1d4fc32?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  yogya: "https://images.pexels.com/photos/36207649/pexels-photo-36207649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  yogya2: "https://images.pexels.com/photos/36876607/pexels-photo-36876607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rooftop: "https://images.unsplash.com/photo-1513279922550-250c2129b13a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rooftop2: "https://images.pexels.com/photos/37844216/pexels-photo-37844216.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// budget tiers: hemat (<120k), sedang (120-220k), premium (>220k)
export const DESTINATIONS = [
  // ---- JAKARTA (supplied assets) ----
  {
    id: "jkt-tanah-temu",
    name: "Tanah & Temu Studio",
    city: "Jakarta", area: "Kemang", category: "Crafting",
    price: 180000, rating: 4.9,
    img: "/assets/destinations/tanah-temu-pottery.png",
    gallery: ["/assets/destinations/tanah-temu-pottery.png", IMG.pottery2, IMG.batik],
    desc: "Kelas keramik berdua — bentuk cangkir kalian sendiri, lalu bawa pulang sebagai kenang-kenangan.",
    amenities: ["Semua bahan disediakan", "Instruktur pendamping", "Kopi & teh gratis", "Ramah pemula"],
    moods: ["tenang", "kreatif"], budget: "sedang", setting: "indoor",
  },
  {
    id: "jkt-sore-kebun",
    name: "Sore di Kebun",
    city: "Jakarta", area: "Cilandak", category: "Restaurant",
    price: 240000, rating: 4.8,
    img: "/assets/destinations/sore-di-kebun.png",
    gallery: ["/assets/destinations/sore-di-kebun.png", IMG.garden2, IMG.garden],
    desc: "Makan malam di tengah taman dengan lampu hangat. Menu nusantara modern untuk berdua.",
    amenities: ["Area outdoor", "Menu couple set", "Live acoustic akhir pekan", "Reservasi meja"],
    moods: ["romantis", "santai"], budget: "premium", setting: "outdoor",
  },
  {
    id: "jkt-ruang-rasa",
    name: "Ruang Rasa Gallery",
    city: "Jakarta", area: "Menteng", category: "Museum",
    price: 100000, rating: 4.8,
    img: "/assets/destinations/ruang-rasa-gallery.png",
    gallery: ["/assets/destinations/ruang-rasa-gallery.png", IMG.gallery, IMG.gallery2],
    desc: "Galeri seni kontemporer dengan instalasi interaktif. Cocok untuk ngobrol pelan sambil menikmati karya.",
    amenities: ["Tiket 2 orang", "Pameran rutin", "Kafe di dalam", "Spot foto estetik"],
    moods: ["tenang", "kreatif"], budget: "hemat", setting: "indoor",
  },
  {
    id: "jkt-langit-senja",
    name: "Langit Senja Park",
    city: "Jakarta", area: "Ancol", category: "Rides",
    price: 160000, rating: 4.7,
    img: "/assets/destinations/langit-senja-park.png",
    gallery: ["/assets/destinations/langit-senja-park.png", IMG.ferris, IMG.ferris2],
    desc: "Taman hiburan tepi pantai. Naik bianglala saat matahari terbenam, klasik tapi selalu manis.",
    amenities: ["Tiket terusan wahana", "Bianglala senja", "Jajanan pantai", "Area foto"],
    moods: ["seru", "romantis"], budget: "sedang", setting: "outdoor",
  },
  {
    id: "jkt-piknik-danau",
    name: "Piknik Tepi Danau",
    city: "Jakarta", area: "Jagakarsa", category: "Wisata Alam",
    price: 90000, rating: 4.8,
    img: "/assets/destinations/piknik-tepi-danau.png",
    gallery: ["/assets/destinations/piknik-tepi-danau.png", IMG.lake, IMG.lake2],
    desc: "Paket piknik lengkap tepi danau: tikar, keranjang, dan camilan. Tinggal datang dan bersantai.",
    amenities: ["Set piknik untuk 2", "Tikar & bantal", "Keranjang camilan", "Area teduh"],
    moods: ["santai", "tenang"], budget: "hemat", setting: "outdoor",
  },
  {
    id: "jkt-atap-cerita",
    name: "Atap Cerita",
    city: "Jakarta", area: "Setiabudi", category: "Restaurant",
    price: 280000, rating: 4.9,
    img: "/assets/destinations/atap-cerita.png",
    gallery: ["/assets/destinations/atap-cerita.png", IMG.rooftop, IMG.rooftop2],
    desc: "Rooftop dinner dengan pemandangan lampu kota. Momen spesial untuk anniversary atau kejutan.",
    amenities: ["Meja tepi kaca", "Menu tasting berdua", "Pemandangan skyline", "Dress code smart casual"],
    moods: ["romantis"], budget: "premium", setting: "outdoor",
  },

  // ---- BANDUNG ----
  {
    id: "bdg-kabut-kopi",
    name: "Kabut & Kopi",
    city: "Bandung", area: "Lembang", category: "Restaurant",
    price: 150000, rating: 4.7,
    img: IMG.bandungCafe,
    gallery: [IMG.bandungCafe, IMG.bandungMt, IMG.garden],
    desc: "Kafe kaca menghadap hutan pinus berkabut. Cokelat panas berdua saat udara sejuk.",
    amenities: ["View pegunungan", "Menu couple", "Area outdoor", "Parkir luas"],
    moods: ["tenang", "romantis"], budget: "sedang", setting: "indoor",
  },
  {
    id: "bdg-puncak-bintang",
    name: "Puncak Bintang",
    city: "Bandung", area: "Cimenyan", category: "Wisata Alam",
    price: 80000, rating: 4.6,
    img: IMG.bandungMt,
    gallery: [IMG.bandungMt, IMG.lake, IMG.lake2],
    desc: "Bukit dengan panorama kota Bandung. Datang sore, tunggu lampu kota menyala satu per satu.",
    amenities: ["Tiket masuk 2 orang", "Spot sunset", "Trek ringan", "Warung lokal"],
    moods: ["santai", "seru"], budget: "hemat", setting: "outdoor",
  },
  {
    id: "bdg-tangan-tanah",
    name: "Tangan & Tanah",
    city: "Bandung", area: "Dago", category: "Crafting",
    price: 170000, rating: 4.8,
    img: IMG.pottery,
    gallery: [IMG.pottery, IMG.pottery2, IMG.batik2],
    desc: "Workshop keramik intim di kawasan Dago. Suasana hangat, cocok untuk yang suka bikin sesuatu bareng.",
    amenities: ["Bahan lengkap", "Instruktur", "Hasil dibakar & dikirim", "Camilan"],
    moods: ["kreatif", "tenang"], budget: "sedang", setting: "indoor",
  },
  {
    id: "bdg-galeri-lanskap",
    name: "Galeri Lanskap",
    city: "Bandung", area: "Braga", category: "Museum",
    price: 75000, rating: 4.6,
    img: IMG.gallery,
    gallery: [IMG.gallery, IMG.gallery2, IMG.batik],
    desc: "Galeri seni di gedung heritage Braga. Jalan pelan sambil menikmati lukisan dan arsitektur lama.",
    amenities: ["Tiket 2 orang", "Tur singkat", "Kafe klasik", "Bangunan bersejarah"],
    moods: ["tenang", "kreatif"], budget: "hemat", setting: "indoor",
  },

  // ---- YOGYAKARTA ----
  {
    id: "yog-candi-senja",
    name: "Candi Senja Prambanan",
    city: "Yogyakarta", area: "Sleman", category: "Wisata Alam",
    price: 110000, rating: 4.9,
    img: IMG.yogya,
    gallery: [IMG.yogya, IMG.yogya2, IMG.lake],
    desc: "Menyusuri kompleks candi megah menjelang senja. Sejarah dan pemandangan dalam satu kencan.",
    amenities: ["Tiket 2 orang", "Pemandu opsional", "Spot sunset", "Area luas"],
    moods: ["tenang", "seru"], budget: "hemat", setting: "outdoor",
  },
  {
    id: "yog-batik-berdua",
    name: "Batik Berdua",
    city: "Yogyakarta", area: "Kotagede", category: "Crafting",
    price: 130000, rating: 4.8,
    img: IMG.batik,
    gallery: [IMG.batik, IMG.batik2, IMG.pottery],
    desc: "Belajar membatik tulis bersama pengrajin. Buat kain motif kalian sendiri sebagai kenangan.",
    amenities: ["Alat & kain", "Pengrajin lokal", "Hasil dibawa pulang", "Teh & jajan pasar"],
    moods: ["kreatif", "tenang"], budget: "sedang", setting: "indoor",
  },
  {
    id: "yog-teras-kota",
    name: "Teras Kota Tua",
    city: "Yogyakarta", area: "Malioboro", category: "Restaurant",
    price: 140000, rating: 4.7,
    img: IMG.rooftop2,
    gallery: [IMG.rooftop2, IMG.rooftop, IMG.garden2],
    desc: "Rooftop bergaya klasik dekat Malioboro. Makan malam ditemani lampu jalan yang syahdu.",
    amenities: ["Meja rooftop", "Menu Jawa modern", "Live gamelan", "Reservasi"],
    moods: ["romantis", "santai"], budget: "sedang", setting: "outdoor",
  },

  // ---- SOLO ----
  {
    id: "solo-taman-sari",
    name: "Taman Balekambang",
    city: "Solo", area: "Banjarsari", category: "Wisata Alam",
    price: 60000, rating: 4.6,
    img: IMG.lake2,
    gallery: [IMG.lake2, IMG.lake, IMG.garden],
    desc: "Taman kota rindang dengan danau kecil. Jalan santai sambil kasih makan rusa dan ngobrol.",
    amenities: ["Masuk 2 orang", "Danau & taman", "Rusa jinak", "Piknik ringan"],
    moods: ["santai", "tenang"], budget: "hemat", setting: "outdoor",
  },
  {
    id: "solo-rumah-rasa",
    name: "Rumah Rasa Solo",
    city: "Solo", area: "Laweyan", category: "Restaurant",
    price: 120000, rating: 4.7,
    img: IMG.garden,
    gallery: [IMG.garden, IMG.garden2, IMG.rooftop],
    desc: "Resto di rumah joglo tua dengan taman dalam. Sajian khas Solo dalam suasana tenang.",
    amenities: ["Suasana joglo", "Menu couple", "Taman dalam", "Reservasi meja"],
    moods: ["romantis", "tenang"], budget: "sedang", setting: "indoor",
  },
  {
    id: "solo-galeri-batik",
    name: "Galeri Batik Laweyan",
    city: "Solo", area: "Laweyan", category: "Museum",
    price: 70000, rating: 4.6,
    img: IMG.batik2,
    gallery: [IMG.batik2, IMG.batik, IMG.gallery],
    desc: "Museum dan galeri batik di kampung Laweyan. Belajar sejarah wastra sambil jalan berdua.",
    amenities: ["Tiket 2 orang", "Pemandu", "Koleksi wastra", "Toko suvenir"],
    moods: ["kreatif", "tenang"], budget: "hemat", setting: "indoor",
  },

  // ---- SURABAYA ----
  {
    id: "sby-atap-pahlawan",
    name: "Atap Pahlawan",
    city: "Surabaya", area: "Gubeng", category: "Restaurant",
    price: 220000, rating: 4.8,
    img: IMG.rooftop,
    gallery: [IMG.rooftop, IMG.rooftop2, IMG.garden2],
    desc: "Rooftop modern menghadap skyline Surabaya. Cocok untuk makan malam spesial berdua.",
    amenities: ["Meja tepi kaca", "Menu tasting", "View kota", "Smart casual"],
    moods: ["romantis"], budget: "premium", setting: "outdoor",
  },
  {
    id: "sby-taman-bungkul",
    name: "Taman Bungkul",
    city: "Surabaya", area: "Darmo", category: "Wisata Alam",
    price: 50000, rating: 4.5,
    img: IMG.lake,
    gallery: [IMG.lake, IMG.lake2, IMG.garden],
    desc: "Taman kota ikonik untuk jalan sore. Jajan street food lokal sambil duduk santai.",
    amenities: ["Akses bebas", "Street food", "Area teduh", "Spot musik jalanan"],
    moods: ["santai", "seru"], budget: "hemat", setting: "outdoor",
  },
  {
    id: "sby-studio-clay",
    name: "Studio Clay Suroboyo",
    city: "Surabaya", area: "Wonokromo", category: "Crafting",
    price: 165000, rating: 4.7,
    img: IMG.pottery2,
    gallery: [IMG.pottery2, IMG.pottery, IMG.batik],
    desc: "Kelas keramik santai dengan playlist enak. Bikin karya berdua tanpa buru-buru.",
    amenities: ["Bahan lengkap", "Instruktur", "Hasil dikirim", "Free drinks"],
    moods: ["kreatif", "santai"], budget: "sedang", setting: "indoor",
  },

  // ---- BALI ----
  {
    id: "bali-sunset-club",
    name: "Sunset Beach Club",
    city: "Bali", area: "Canggu", category: "Restaurant",
    price: 300000, rating: 4.9,
    img: IMG.bali,
    gallery: [IMG.bali, IMG.bali2, IMG.rooftop],
    desc: "Beach club tepi laut dengan sunset legendaris. Duduk berdua, dengar ombak, nikmati senja.",
    amenities: ["Beanbag tepi pantai", "Menu couple", "Sunset view", "Live DJ sore"],
    moods: ["romantis", "santai"], budget: "premium", setting: "outdoor",
  },
  {
    id: "bali-ombak-park",
    name: "Ombak Waterpark",
    city: "Bali", area: "Nusa Dua", category: "Rides",
    price: 190000, rating: 4.6,
    img: IMG.ferris2,
    gallery: [IMG.ferris2, IMG.ferris, IMG.bali2],
    desc: "Taman wahana tepi pantai. Seru-seruan basah-basahan lalu santai lihat laut.",
    amenities: ["Tiket terusan", "Wahana air", "Loker & handuk", "Kafe pantai"],
    moods: ["seru"], budget: "sedang", setting: "outdoor",
  },
  {
    id: "bali-galeri-ubud",
    name: "Galeri Seni Ubud",
    city: "Bali", area: "Ubud", category: "Museum",
    price: 120000, rating: 4.8,
    img: IMG.gallery2,
    gallery: [IMG.gallery2, IMG.gallery, IMG.batik],
    desc: "Museum seni Bali di tengah sawah Ubud. Tenang, teduh, penuh karya yang menenangkan.",
    amenities: ["Tiket 2 orang", "Taman sawah", "Kafe organik", "Spot foto"],
    moods: ["tenang", "kreatif"], budget: "sedang", setting: "indoor",
  },
  {
    id: "bali-tepi-sawah",
    name: "Piknik Tepi Sawah",
    city: "Bali", area: "Tegalalang", category: "Wisata Alam",
    price: 100000, rating: 4.7,
    img: IMG.lake2,
    gallery: [IMG.lake2, IMG.bali, IMG.garden],
    desc: "Piknik menghadap terasering hijau. Sarapan berdua ditemani suara alam Ubud.",
    amenities: ["Set piknik 2 orang", "View terasering", "Tikar & payung", "Menu lokal"],
    moods: ["tenang", "romantis"], budget: "hemat", setting: "outdoor",
  },
];

export const getDestination = (id) => DESTINATIONS.find((d) => d.id === id);

// Approximate coordinates per destination for the city map view
export const COORDS = {
  "jkt-tanah-temu": [-6.260, 106.813], "jkt-sore-kebun": [-6.288, 106.799],
  "jkt-ruang-rasa": [-6.196, 106.832], "jkt-langit-senja": [-6.124, 106.833],
  "jkt-piknik-danau": [-6.335, 106.826], "jkt-atap-cerita": [-6.209, 106.829],
  "bdg-kabut-kopi": [-6.812, 107.617], "bdg-puncak-bintang": [-6.856, 107.660],
  "bdg-tangan-tanah": [-6.885, 107.613], "bdg-galeri-lanskap": [-6.917, 107.609],
  "yog-candi-senja": [-7.752, 110.491], "yog-batik-berdua": [-7.826, 110.399],
  "yog-teras-kota": [-7.792, 110.365],
  "solo-taman-sari": [-7.556, 110.818], "solo-rumah-rasa": [-7.566, 110.797],
  "solo-galeri-batik": [-7.568, 110.799],
  "sby-atap-pahlawan": [-7.265, 112.751], "sby-taman-bungkul": [-7.291, 112.739],
  "sby-studio-clay": [-7.302, 112.736],
  "bali-sunset-club": [-8.648, 115.137], "bali-ombak-park": [-8.803, 115.228],
  "bali-galeri-ubud": [-8.507, 115.263], "bali-tepi-sawah": [-8.431, 115.279],
};

export const CITY_MAP = {
  Jakarta: { center: [-6.2088, 106.8156], zoom: 11 },
  Bandung: { center: [-6.8875, 107.6191], zoom: 12 },
  Yogyakarta: { center: [-7.790, 110.418], zoom: 11 },
  Solo: { center: [-7.563, 110.808], zoom: 12 },
  Surabaya: { center: [-7.286, 112.742], zoom: 12 },
  Bali: { center: [-8.610, 115.230], zoom: 10 },
};

export const REWARDS = [
  { id: "rw-25", value: 25000, cost: 250, minSpend: 50000, label: "Diskon Rp25.000",
    desc: "Potongan untuk kencan berikutnya, min. transaksi Rp50.000." },
  { id: "rw-50", value: 50000, cost: 500, minSpend: 100000, label: "Diskon Rp50.000",
    desc: "Potongan lebih besar, min. transaksi Rp100.000." },
  { id: "rw-100", value: 100000, cost: 1000, minSpend: 200000, label: "Diskon Rp100.000",
    desc: "Hemat maksimal untuk kencan spesial, min. transaksi Rp200.000." },
];

// Venue dari dashboard admin (tambahan / override / nonaktif) — dimutasi in-place agar semua importer ikut
export function applyVenueOverrides({ custom = [], overrides = {} } = {}) {
  Object.entries(overrides).forEach(([id, patch]) => {
    const d = DESTINATIONS.find((x) => x.id === id);
    if (d) Object.assign(d, patch);
  });
  custom.forEach((v) => {
    const idx = DESTINATIONS.findIndex((x) => x.id === v.id);
    const doc = { gallery: [v.img], amenities: [], moods: [], ...v };
    if (idx >= 0) DESTINATIONS[idx] = doc; else DESTINATIONS.push(doc);
    if (v.city && !CITIES.includes(v.city)) CITIES.push(v.city);
  });
  for (let i = DESTINATIONS.length - 1; i >= 0; i--) if (DESTINATIONS[i].active === false) DESTINATIONS.splice(i, 1);
}
